import {
  HomeIcon,
  ProfileIcon,
  BagIcon,
  HospitalIcon,
  MedicIcon,
} from "../../../components/UIElements/svgIcons";
import {
  PATH_DASHBOARD,
  PATH_HOSPITAL,
  PATH_JOBMANAGEMENT,
  PATH_MEDIC,
  PATH_OUTSOURCING,
  PATH_PROFILE,
  PATH_SUBSCRIPTION,
  PATH_SUPPORT,
  PATH_USER,
} from "../../../routes/path";
import {
  SupportIcons,
  UserIcon,
} from "../../../components/UIElements/svg-icons";
import Cookies from "js-cookie";
import config from "../../../utils/config";

const NavConfig = () => {
  const userData = Cookies.get(config.key.admin);
  const user_info =
    userData && userData.trim() ? JSON.parse(userData) : { role: "" };
  const content = [
    {
      title: "Home",
      path: PATH_DASHBOARD.root,
      icon: <HomeIcon />,
    },
    {
      title: "Hospital Mgt.",
      path: PATH_HOSPITAL.root,
      icon: <HospitalIcon />,
    },
    {
      title: "Medic Management",
      path: PATH_MEDIC.root,
      icon: <MedicIcon />,
    },
    {
      title: "User Management",
      path: PATH_USER.root,
      icon: <UserIcon />,
    },
    {
      title: "Job Management",
      path: PATH_JOBMANAGEMENT.root,
      icon: <BagIcon />,
    },
    {
      title: "Support and Help",
      path: PATH_SUPPORT.root,
      icon: <SupportIcons />,
    },
    {
      title: "Outsourcing",
      path: PATH_OUTSOURCING.root,
      icon: <BagIcon />,
    },
    // {
    //   title: "Subscription plans",
    //   path: PATH_SUBSCRIPTION.root,
    //   icon: <SubscriptionIcon />,
    // },
    {
      title: "Profile",
      path: PATH_PROFILE.root,
      icon: <ProfileIcon />,
    },
  ];
  const sub_content = [
    {
      title: "Home",
      path: PATH_DASHBOARD.root,
      icon: <HomeIcon />,
    },
    {
      title: "Hospital Mgt.",
      path: PATH_HOSPITAL.root,
      icon: <HospitalIcon />,
    },
    {
      title: "Medic Management",
      path: PATH_MEDIC.root,
      icon: <MedicIcon />,
    },

    {
      title: "Job Management",
      path: PATH_JOBMANAGEMENT.root,
      icon: <BagIcon />,
    },
    {
      title: "Outsourcing",
      path: PATH_OUTSOURCING.root,
      icon: <BagIcon />,
    },
    {
      title: "Support and Help",
      path: PATH_SUPPORT.root,
      icon: <SupportIcons />,
    },

    {
      title: "Profile",
      path: PATH_PROFILE.root,
      icon: <ProfileIcon />,
    },
  ];

  return user_info?.role === "superAdmin" ? content : sub_content;
};

export default NavConfig;
